import { Link } from 'react-router-dom'
import { CheckCircle } from 'lucide-react'
import { AuthLayout } from '@/modules/auth/ui/components'
import { Button } from '@/shared/ui/primitives'

export type AlreadyRegisteredStateProps = {
  organizationName?: string
}

export function AlreadyRegisteredState({ organizationName }: AlreadyRegisteredStateProps) {
  const subtitle = organizationName
    ? `You've already joined ${organizationName}.`
    : 'You have already registered with this invitation.'

  return (
    <AuthLayout title="Already registered" subtitle={subtitle}>
      <div className="flex flex-col gap-4">
        <div className="flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-sage-soft">
            <CheckCircle className="h-8 w-8 text-sage" aria-hidden />
          </div>
        </div>
        <p className="text-sm text-muted-foreground">
          Sign in with the email you used during registration to continue to your dashboard.
        </p>
        <Button asChild variant="default" className="w-full">
          <Link to="/sign-in">Sign in</Link>
        </Button>
      </div>
    </AuthLayout>
  )
}
